import { render, staticRenderFns } from "./LanguagesRadio.vue?vue&type=template&id=238135e3&scoped=true"
import script from "./LanguagesRadio.vue?vue&type=script&lang=js"
export * from "./LanguagesRadio.vue?vue&type=script&lang=js"
import style0 from "./LanguagesRadio.vue?vue&type=style&index=0&id=238135e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238135e3",
  null
  
)

export default component.exports